/**
 * Trạng thái đối chiếu MISA của một dòng hoá đơn AI.
 *
 * Bản sao của luật backend (uniapp `utils/invoice-ocr-doi-chieu.util.js`):
 * suy ra từ `matchStatus` và `traMisa` mà dòng vốn đã có. Sửa một bên thì sửa
 * cả bên kia — test ở hai repo cùng khoá một bảng ca.
 */

export const TRANG_THAI_MISA = {
  'chua-kiem': { nhan: 'Chưa kiểm', bg: 'secondary', hint: 'Chưa hỏi MISA về tờ này.' },
  khop: { nhan: 'Khớp MISA', bg: 'success', hint: 'MISA có đúng tờ này (đã đồng bộ hoặc tra theo số ra một tờ).' },
  'khong-khop': { nhan: 'Không khớp', bg: 'warning', hint: 'Đã hỏi MISA nhưng không ra đúng một tờ (không có, ra nhiều tờ, hoặc thiếu số/ký hiệu để tra).' },
  loi: { nhan: 'Lỗi tra MISA', bg: 'danger', hint: 'Không hỏi được MISA (mạng / tài khoản) — thử đối chiếu lại.' },
};

const TRA_KHONG_KHOP = new Set(['khong', 'nhieu', 'khong-du-khoa']);

export function trangThaiMisa(item) {
  if (!item) return 'chua-kiem';
  const tra = item.traMisa || '';
  if (item.matchStatus === 'matched' || tra === 'khop-mongo' || tra === 'mot') return 'khop';
  if (tra === 'loi') return 'loi';
  if (TRA_KHONG_KHOP.has(tra)) return 'khong-khop';
  return 'chua-kiem';
}
